export const REGISTER_POA_LOADING = 'REGISTER_POA_LOADING';

export const REGISTER_POA_ERROR = 'REGISTER_POA_ERROR';

export const INITIATE_REGISTER_POA_APPLICATION_SUCCESS = 'INITIATE_REGISTER_POA_APPLICATION_SUCCESS';

export const RESET_REGISTER_POA_REDUCER = 'RESET_REGISTER_POA_REDUCER';

export const FETCH_APPLICATION_REGISTER_POA_SUCCESS = 'FETCH_APPLICATION_REGISTER_POA_SUCCESS';

export const FETCH_DOCUMENTS_REGISTER_POA_SUCCESS = 'FETCH_DOCUMENTS_REGISTER_POA_SUCCESS';

export const REGISTER_POA_CLEAR_DATA = 'REGISTER_POA_CLEAR_DATA';

export const DOWNLOAD_DOCUMENT_REGISTER_POA_SUCCESS = 'DOWNLOAD_DOCUMENT_REGISTER_POA_SUCCESS';

export const REGISTER_POA_CANCEL_APPLICATION_SUCCESS = 'REGISTER_POA_CANCEL_APPLICATION_SUCCESS';

export const ADD_TO_ERROR = 'ADD_TO_ERROR';

export const CHANGE_REGISTER_POA_STEP = 'CHANGE_REGISTER_POA_STEP';

export const FETCH_EMPLOYEE_PERMISSIONS_SUCCESS = 'FETCH_EMPLOYEE_PERMISSIONS_SUCCESS';

export const UPDATE_INFO_FORM_FIELD = 'UPDATE_INFO_FORM_FIELD';

export const FETCH_POA_DETAILS_SUCCESS = 'FETCH_POA_DETAILS_SUCCESS';

export const FETCH_COMPANY_SUCCESS = 'FETCH_COMPANY_SUCCESS';

export const UPDATE_FETCHED_USER_INFO = 'UPDATE_FETCHED_USER_INFO';

export const UPDATE_SELECTED_PERMISSION = 'UPDATE_SELECTED_PERMISSION';

export const REGISTER_POA_DOCUMENT_CHANGE_STATE = 'REGISTER_POA_DOCUMENT_CHANGE_STATE';

export const SAVE_APPLICATION_REGISTER_POA_SUCCESS = 'SAVE_APPLICATION_REGISTER_POA_SUCCESS';

export const ADD_POA_SUCCESS = 'ADD_POA_SUCCESS';

export const UPDATE_ADDED_EMPLOYEE_INFORMATION = 'UPDATE_ADDED_EMPLOYEE_INFORMATION';

export const UPDATE_POA_SOURCE = 'UPDATE_POA_SOURCE';

export const UPDATE_POA_DETAILS_FIELDS = 'UPDATE_POA_DETAILS_FIELDS';

export const FETCH_POA_CONTRACT_DETAILS_SUCCESS = 'FETCH_POA_CONTRACT_DETAILS_SUCCESS';

export const FETCH_MULTI_PROPERTIES_SUCCESS = 'FETCH_MULTI_PROPERTIES_SUCCESS';

export const REGISTER_POA_FETCH_LOOKUPS_SUCCESS = 'REGISTER_POA_FETCH_LOOKUPS_SUCCESS';

export const FETCH_COUNTRIES_SUCCESS = 'FETCH_COUNTRIES_SUCCESS';

export const FETCH_CITIES_SUCCESS = 'FETCH_CITIES_SUCCESS';

export const ADD_ENTITY_SUCCESS = 'ADD_ENTITY_SUCCESS';

export const FETCH_SINGLE_PROPERTY_DETAILS_SUCCESS = 'FETCH_SINGLE_PROPERTY_DETAILS_SUCCESS';

export const TERMINATE_APPLICATION_SUCCESS = 'TERMINATE_APPLICATION_SUCCESS';
export const DELETE_PARTY_SUCCESS = 'DELETE_PARTY_SUCCESS';
